import { render, staticRenderFns } from "./DashboardNavPanel.vue?vue&type=template&id=65beedae"
import script from "./DashboardNavPanel.vue?vue&type=script&lang=ts"
export * from "./DashboardNavPanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports